<footer class="footer-login">
    <p [innerHTML]="copyright" class="footer-login__copyright"></p>
    @if (cookiePolicy) {
        <a
            [core-analytics]="{ action: 'Cookie policy', category: 'LOGIN' }"
            class="CookieReportsLink footer-login__cookie-policy"
            [href]="'//policy.cookiereports.com/' + cookiePolicy + '-en-gb.html'">
            <small>{{ 'Cookie Policy' | translate }}</small>
        </a>
        @if (cookiePolicyUsCompliance) {
            <a
                [core-analytics]="{
                    action: 'Do Not Sell or Share My Personal Information',
                    category: 'LOGIN',
                }"
                class="CookieReportsLink footer-login__cookie-policy"
                [href]="'//policy.cookiereports.com/' + cookiePolicy + '-en-gb.html'">
                <small>{{ 'Do Not Sell or Share My Personal Information' | translate }}</small>
            </a>
        }
    }
</footer>
